module.exports = __webpack_public_path__ + "img/sq4d_01.eebf9d29.jpg";